import { useEffect, useRef, useState } from 'react';

// material-ui
import { CircularProgress, Grid2, Stack } from '@mui/material';

// project-imports
import ComponentWrapper from 'sections/components-overview/ComponentWrapper';


// ==============================|| COMPONENTS - PROGRESS ||============================== //

const Loader2 = () => {
  const [bufferProgress, setBufferProgress] = useState(0);

  const progressRef = useRef(() => {});
  useEffect(() => {
    progressRef.current = () => {
      if (bufferProgress > 100) {
        setBufferProgress(0);
      } else {
        const diff = Math.random() * 10;
       
        setBufferProgress(bufferProgress + diff);
      }
    };
  });

  useEffect(() => {
    const bufferTimer = setInterval(() => {
      progressRef.current();
    }, 500);

    return () => {
      clearInterval(bufferTimer);
    };
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
   
      <ComponentWrapper>
        <Stack spacing={3}>
          <Grid2 container spacing={3} alignItems="center">
            <Grid2 >
              <CircularProgress size={50} />
            </Grid2>
          </Grid2>
        </Stack>
      </ComponentWrapper>
      
    </div>
  );
};

export default Loader2;
